import React from "react";
import {
  Snackbar,
  Alert,
  Button,
  IconButton,
  Typography,
  Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SettingsIcon from "@mui/icons-material/Settings";

const NotificationPrompt = ({
  open,
  permission,
  onEnable,
  onOpenBrowserSettings,
  onClose,
}) => {
  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      sx={{ mb: 3, mr: 3 }}
    >
      <Alert
        icon={false}
        variant="filled"
        sx={{
          width: 360,
          bgcolor: "#0f172a",
          borderRadius: 2,
          boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
        }}
        action={
          <IconButton size="small" onClick={onClose} aria-label="Dismiss">
            <CloseIcon fontSize="small" sx={{ color: "#fff" }} />
          </IconButton>
        }
      >
        <Typography fontWeight={700} fontSize={14} color="#fff">
          Enable Push Notifications
        </Typography>

        <Typography fontSize={13} color="#cbd5f5" mt={0.5}>
          Receive important alerts directly in your browser.
        </Typography>

        <Stack direction="row" spacing={1.5} mt={1.5}>
          {permission === "default" && (
            <Button
              size="small"
              onClick={onEnable}
              sx={{
                bgcolor: "#38bdf8",
                color: "#020617",
                fontWeight: 600,
                textTransform: "none",
              }}
            >
              Enable
            </Button>
          )}

          {permission === "denied" && (
            <Button
              size="small"
              startIcon={<SettingsIcon />}
              onClick={onOpenBrowserSettings}
              sx={{
                bgcolor: "#334155",
                color: "#fff",
                fontWeight: 600,
                textTransform: "none",
              }}
            >
              Browser Settings
            </Button>
          )}
        </Stack>
      </Alert>
    </Snackbar>
  );
};

export default NotificationPrompt;
